import { createActions, createTypes, createReducer } from './util'

export const namespace = 'analytics'

const typeKeys = [
  'BOOK',
  'SHARE_OPEN',
  'SHARE_CLOSE'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

export const initialState = {
  items: {}
}

const reducer = {}

export default createReducer(initialState, reducer)

function createSelectors () {}

export const selectors = createSelectors()
